const Sorting = {
  CREATED: "created",
  MODIFIED: "modified",
  TITLE: "title",
};

const Ordering = {
  ASCENDING: "ascending",
  DESCENDING: "descending",
};

const CurrentSpaceOption = {
  icon: undefined,
  name: "Current Space",
  spaceKey: "current-space-hardcoded",
  type: "space",
  label: "Current Space",
  value: "current-space-hardcoded",
  homepageId: "undefined",
  coverPictureCallback: async () => {},
};
const CurrentPageOption = {
  contentId: "current-page-hardcoded",
  type: "page",
  name: "Current Page",
  space: undefined,
  excerpt: "",
  url: undefined,
  createdBy: undefined,
  lastModified: undefined,
  label: "Current Page",
  value: "current-page-hardcoded",
};

export async function searchPages({ queryKey, pageParam }) {
  const [
    _key,
    {
      labels = [],
      contributors = [],
      spaces = [],
      parentPageId = undefined,
      limit = 2,
      sorting = Sorting.CREATED,
      ordering = Ordering.DESCENDING,
      excludePersonalSpaces = false,
      currentSpaceKey = undefined,
      currentPageId = undefined,
    },
  ] = queryKey;
  let cql = "type in (page, blogpost)";
  if (labels.length > 0) {
    cql = cql + ` AND label in (${labels.map((l) => `"${l}"`).join(",")})`;
  }
  if (contributors.length > 0) {
    cql =
      cql +
      ` AND contributor.accountid in (${contributors
        .map((c) => `"${c}"`)
        .join(",")})`;
  }
  if (excludePersonalSpaces) {
    cql = cql + ` AND space.type=global`;
  }
  if (spaces.length > 0) {
    const indexOfCurrentSpaceOption = spaces.findIndex(
      (spaceKey) => spaceKey === CurrentSpaceOption.spaceKey
    );
    if (indexOfCurrentSpaceOption >= 0) {
      if (currentSpaceKey) {
        spaces.splice(indexOfCurrentSpaceOption, 1, currentSpaceKey);
      } else {
        spaces.splice(indexOfCurrentSpaceOption, 1);
      }
    }

    cql = cql + ` AND space in (${spaces.map((s) => `"${s}"`).join(",")})`;
  }
  if (parentPageId) {
    if (parentPageId === CurrentPageOption.contentId && currentPageId) {
      cql = cql + ` AND parent=${currentPageId}`;
    } else {
      cql = cql + ` AND parent=${parentPageId}`;
    }
  }
  if (sorting === Sorting.CREATED) {
    cql = cql + ` ORDER BY created`;
  }
  if (sorting === Sorting.MODIFIED) {
    cql = cql + ` ORDER BY lastmodified`;
  }
  if (sorting === Sorting.TITLE) {
    cql = cql + ` ORDER BY title`;
  }
  if (ordering === Ordering.ASCENDING) {
    cql = cql + ` asc`;
  }
  if (ordering === Ordering.DESCENDING) {
    cql = cql + ` desc`;
  }

  let url = `/rest/api/search?cql=${cql}&limit=${limit}&expand=content.history,content.space,content.metadata.labels,content.metadata.likes,content.children.comment`;
  if (pageParam) {
    url = `${url}&cursor=${decodeURI(pageParam)}`;
  }
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch blogposts");
    console.log(e);
  }
}

export async function getPageById(contentId) {
  const url = `/rest/api/search?cql=type in (page, blogpost) and id=${contentId}&limit=1&expand=content.history,content.space,content.metadata.labels,content.metadata.likes,content.children.comment`;

  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch page", contentId);
    console.log(e);
    return undefined;
  }
}

export async function getPagesById(contentId) {
  const url = `/api/v2/pages?id=${contentId.join(",")}`;

  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch page", contentId);
    console.log(e);
    return undefined;
  }
}

export async function getCurrentUserPageWatchStatus(contentId) {
  const url = `/rest/api/user/watch/content/${contentId}`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch watch status");
    console.log(e);
  }
}
